import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  progress = false;
  alertError = false;
  alertSucces = false;
  alertFail = false;
  alertErrorBloqueado = false;
  alertBloqueoFinanciero = false;
  btnEnviar = false;

  LoginForm: FormGroup;
  constructor(private router: Router, private fb: FormBuilder, private service: AuthService) {
    this.LoginForm = this.fb.group({
      Usuario: ['', Validators.required],
      Captcha: ['', Validators.required],
      Clave: ['', [Validators.required, Validators.maxLength(16), Validators.minLength(3)]]
    });
  }

  ngOnInit(): void {
    // This is intentional
  }
  
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  resolved(captchaResponse: string) {
    console.log('Resolved captcha.');
  }

  Autenticar() {
    this.validateAllFormFields(this.LoginForm);
    if (this.LoginForm.valid) {
      this.progress = true;
      this.service.logIn(this.LoginForm.controls.Usuario.value, this.LoginForm.controls.Clave.value).subscribe(
        (data: any) => {
          this.progress = false;
          console.log(JSON.stringify(data));
          if (data.Token === '') {
            //usuario no valido
            if (!data.usuarioHabilitado) {
              this.alertErrorBloqueado = true;
            } else {
              //COMENTARIO: Se quita la validación de bloqueo financiero por solicitud de Cristian.
              if (data.BloqueoFinanciero) {
                // This is intentional
              } else {
                this.alertError = true;
              }
            }

          } else {
            localStorage.setItem('token', JSON.stringify(data.Token));
            setTimeout(() => {
              this.router.navigateByUrl('/');
            }, 1000);
          }
        },
        (err) => {
          this.alertFail = true;
          this.progress = false;
          setTimeout(() => {
            this.alertFail = false;
          }, 10000);
        }
      );
    }
  }

  openModalListaDeEspera() {
    $('#modalListaDeEspera').modal('show');
  }

  openModalBloqueoAcademico() {
    $('#modalBloqueoAcademico').modal('show');
  }

  openModalBloqueoFinanciero() {
    $('#modalBloqueoFinanciero').modal('show');
  }

  openModalMatriculaActiva() {
    $('#modalExisteMatri').modal('show');
  }
}
